import { useState } from "react";
import { Wallet, ChevronDown, AlertTriangle, LogOut, ExternalLink } from "lucide-react";
import { useWallet, RH_CHAIN_ID, BLOCKSCOUT_URL } from "../lib/wallet";
import { shortAddr } from "../lib/format";
import { Link } from "react-router-dom";

export default function ConnectWallet() {
  const { account, chainId, balance, connect, disconnect, switchChain, hasWallet } = useWallet();
  const [open, setOpen] = useState(false);
  const wrongChain = account && chainId !== RH_CHAIN_ID;

  if (!account) {
    return (
      <button
        data-testid="connect-wallet-button"
        onClick={connect}
        className="flex items-center gap-2 h-8 px-3 bg-[#059669] hover:bg-[#047857] text-white text-[13px] font-medium rounded-sm transition-colors shrink-0"
      >
        <Wallet size={14} /> <span className="hidden sm:inline">Connect Wallet</span>
      </button>
    );
  }

  return (
    <div className="relative shrink-0">
      <button
        data-testid="wallet-menu-button"
        onClick={() => setOpen(!open)}
        className={`flex items-center gap-2 h-8 px-3 border rounded-sm text-[13px] transition-colors ${wrongChain ? "border-[#F59E0B] text-[#F59E0B]" : "border-[#262626] hover:border-[#3F3F46]"}`}
      >
        {wrongChain && <AlertTriangle size={13} />}
        <span className="num">{shortAddr(account)}</span>
        {balance !== null && <span className="num text-[#6B7280] hidden md:inline">{balance.toFixed(4)} ETH</span>}
        <ChevronDown size={13} className="text-[#6B7280]" />
      </button>
      {open && (
        <div className="absolute right-0 top-9 w-56 bg-[#121212] border border-[#262626] rounded-sm z-50 py-1" data-testid="wallet-dropdown">
          {wrongChain && (
            <button onClick={() => { switchChain(); setOpen(false); }} data-testid="switch-chain-button"
              className="w-full text-left px-3 py-2 text-[13px] text-[#F59E0B] hover:bg-[#1A1A1A] flex items-center gap-2">
              <AlertTriangle size={13} /> Switch to Robinhood Chain
            </button>
          )}
          <Link to={`/wallet/${account}`} onClick={() => setOpen(false)} className="block px-3 py-2 text-[13px] hover:bg-[#1A1A1A]" data-testid="view-my-wallet">
            View my wallet profile
          </Link>
          <a href={`${BLOCKSCOUT_URL}/address/${account}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 px-3 py-2 text-[13px] hover:bg-[#1A1A1A] text-[#9CA3AF]">
            <ExternalLink size={12} /> View on Blockscout
          </a>
          <button onClick={() => { disconnect(); setOpen(false); }} data-testid="disconnect-wallet-button"
            className="w-full text-left px-3 py-2 text-[13px] text-[#EF4444] hover:bg-[#1A1A1A] flex items-center gap-2">
            <LogOut size={13} /> Disconnect
          </button>
        </div>
      )}
    </div>
  );
}
